export default "__VITE_ASSET__BFTt$zsL__"